import { ActionCard, ActionCardWrap, IActionCard, TitlePageH1, TitlePageH2 } from '@tap/mui-ui';
import { useEffect } from 'react';
import { AppBasePath } from '../../env';
import AverageAgeIcon from './icons/AverageAgeIcon';
import TaskComparisonIcon from './icons/TaskComparisonIcon';
import RecentlyCreatedTasksIcon from './icons/RecentlyCreatedTasksIcon';
import ComparisonOfStatisticsIcon from './icons/ComparisonOfStatisticsIcon';
import UploadingUsersIcon from './icons/UploadingUsersIcon';
import OutputByDayIcon from './icons/OutputByDayIcon';
import TimeSpentIcon from './icons/TimeSpentIcon';
import StatisticsOnPerformersIcon from './icons/StatisticsOnPerformersIcon';
import PieChartIcon from './icons/PieChartIcon';
import DecisionTimeIcon from './icons/DecisionTimeIcon';

/*
*   Аналитика и отчёты
*/

type IAnalyticsPageProps = {
    title: string,
}


const ANALYTICS = `${AppBasePath}/analytics`;

//Анализ выполнения
export const PerformanceAnalysisCards: IActionCard[] = [
    {
        title: 'Средняя длительность незавершённых заявок',
        description: 'Сформируйте отчёт, который покажет среднюю длительность для незавершённых заявок за указанный период.',
        img: <AverageAgeIcon />,
        link: ANALYTICS + '/average-age',
    },
    {
        title: 'Созданные vs Завершённые заявки',
        description: 'Сформируйте отчёт, который отображает объём завершённых vs объём незавершённых заявок. Отчёт помогает определить динамику нарастания отставания времени выполнения заявок.',
        img: <TaskComparisonIcon />,
        link: ANALYTICS + '/issue-task-comparison',
    },
    {
        title: 'Круговая диаграмма',
        description: 'Сформируйте круговую диаграмму по всем незавершённым заявкам и заявкам, завершённым в указанный период, в разрезе исполнителей.',
        img: <PieChartIcon />,
        link: ANALYTICS + '/issue-pie-chart-by-assignee',
    },
    {
        title: 'Недавно созданные заявки',
        description: 'Сформируйте отчёт, который покажет количество заявок, созданных за указанный период времени, с разделением на завершённые и нет. Отчёт помогает понять справляется ли команда с потоком заявок.',
        img: <RecentlyCreatedTasksIcon />,
        link: ANALYTICS + '/recently-created-issues',
    },
    {
        title: 'Время на решение заявок',
        description: 'Сформируйте отчёт, который покажет, сколько часов прошло с момента создания заявок до их решения, за указанный период. Отчёт помогает понять скорость реагирования вспомогательных служб при решении заявок.',
        img: <DecisionTimeIcon />,
        link: ANALYTICS + '/issue-decision-time',
    },
];

//Прогнозы
export const ForecastCards: IActionCard[] = [
    {
        title: 'План-факт',
        description: 'Сформируйте отчёт, который показывает плановую трудоёмкость по заявке относительно затраченного времени. Это помогает оценить отклонение планового времени выполнения от фактического.',
        img: <ComparisonOfStatisticsIcon />,
        link: ANALYTICS + '/comparison-of-statistics',
    },
    {
        title: 'Загрузка пользователя',
        description: ' Cформируйте отчёт, который показывает оценку времени для всех незавершённых заявок, назначенных на пользователя. Это помогает лучше оценить нагрузку на пользователя.',
        img: <UploadingUsersIcon />,
        link: ANALYTICS + '/issue-uploading-users',
    },
];

//Другое
export const ShiftTaskCards: IActionCard[] = [
    {
        title: 'Статистика по исполнителям',
        description: 'Сформируйте отчёт, который показывает какие пользователи работали над заявками и сколько времени они потратили в указанном периоде.',
        img: <StatisticsOnPerformersIcon />,
        link: ANALYTICS + '/statistics-on-performers',
    },
    {
        title: 'Персональная выработка по дням',
        description: 'Сформируйте отчёт по затратам рабочего времени для пользователя за указанный период.',
        img: <OutputByDayIcon />,
        link: ANALYTICS + '/output_by_day',
    },
    {
        title: 'Затраченное время',
        description: 'Сформируйте отчёт по затратам рабочего времени для заявок за указанный период.',
        img: <TimeSpentIcon />,
        link: ANALYTICS + '/issue-time-spent',
    },
];

export function AnalyticsPage({ title }: IAnalyticsPageProps) {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <>
            <TitlePageH1>{title}</TitlePageH1>
            <TitlePageH2>Анализ выполнения</TitlePageH2>
            <ActionCardWrap>
                {PerformanceAnalysisCards.map((card: IActionCard) => (
                    <ActionCard
                        key={card.title}
                        {...card}
                    />
                ))}
            </ActionCardWrap>

            <TitlePageH2>Прогнозы</TitlePageH2>
            <ActionCardWrap>
                {ForecastCards.map((card: IActionCard) => (
                    <ActionCard
                        key={card.title}
                        {...card}
                    />
                ))}
            </ActionCardWrap>

            <TitlePageH2>Другое</TitlePageH2>
            <ActionCardWrap>
                {ShiftTaskCards.map((card: IActionCard) => (
                    <ActionCard
                        key={card.title}
                        {...card}
                    />
                ))}
            </ActionCardWrap>
        </>
    );
}
